
import Layout from '@/views/layout/layout'
export const glzzcRouters =
  [
    {
      path: '/glzzc',
      iconCls: 'fa el-icon-s-management', // 图标样式class
      name: '隔离种植场',
      component: Layout,
      meta: { role: ['GLZZC'] },
      children: [
        {
          iconCls: 'el-icon-arrow-right',
          path: '/glzzc/receive',
          name: '收货登记',
          meta: { url: "/GLZZC/receive.html" },
          component: () => import('@/views/iframe/index.vue')
        },
        {
          iconCls: 'el-icon-arrow-right',
          path: '/glzzc/isolationManage',
          name: '日常管理',
          meta: { url: "/GLZZC/isolationManage.html" },
          component: () => import('@/views/iframe/index.vue')
        }
      ]
    }
  ]


// WEBPACK FOOTER //
// ./src/router/glzzc.js